import React, { useState, useMemo } from 'react';
import { Link } from 'react-router-dom';
import DataTable from 'datatables.net-react';
import DT from 'datatables.net-dt';
import Responsive from 'datatables.net-responsive';

DataTable.use(DT);
DataTable.use(Responsive);

const Statement: React.FC = () => {
    const [, setDtApi] = useState<any>(null);

    const options = useMemo(() => ({
        responsive: true,
        pageLength: 10,
        lengthChange: false,
        searching: true,
        dom: 'rtip',
        initComplete: (settings: any) => {
            const api = new DT.Api(settings);
            setDtApi(api);
        }
    }), []);

    const statementData = useMemo(() => [
        { date: '13 May 2022', orderId: '3059337', type: 'Transaction Fee', detail: 'Transaction Fee for included payment services charge', price: '$5.00', amount: '$-5.00', amountClass: 'text-danger' },
        { date: '13 May 2022', orderId: '3059337', type: 'Transaction Fee', detail: 'Transaction Fee for sale IP588000', price: '$5.00', amount: '$-5.00', amountClass: 'text-danger' },
        { date: '13 May 2022', orderId: '3059337', type: 'Sale', detail: { title: 'DevUIUX HTML web and admin templates', invoice: 'IP588000' }, price: '$100.00', amount: '$100.00', amountClass: 'text-success' },
        { date: '13 May 2022', orderId: '3059337', type: 'Transaction Fee', detail: 'Transaction Fee for included payment services charge', price: '$5.00', amount: '$-5.00', amountClass: 'text-danger' },
        { date: '13 May 2022', orderId: '3059337', type: 'Transaction Fee', detail: 'Transaction Fee for sale IP588000', price: '$5.00', amount: '$-5.00', amountClass: 'text-danger' },
        { date: '13 May 2022', orderId: '3059337', type: 'Sale', detail: { title: 'DevUIUX HTML web and admin templates', invoice: 'IP588000' }, price: '$100.00', amount: '$100.00', amountClass: 'text-success' },
        { date: '12 May 2022', orderId: '3059337', type: 'Transaction Fee', detail: 'Transaction Fee for included payment services charge', price: '$5.00', amount: '$-5.00', amountClass: 'text-danger' },
        { date: '12 May 2022', orderId: '3059337', type: 'Transaction Fee', detail: 'Transaction Fee for sale IP588000', price: '$5.00', amount: '$-5.00', amountClass: 'text-danger' },
        { date: '12 May 2022', orderId: '3059337', type: 'Sale', detail: { title: 'DevUIUX HTML web and admin templates', invoice: 'IP588000' }, price: '$100.00', amount: '$100.00', amountClass: 'text-success' },
        { date: '11 May 2022', orderId: '3059337', type: 'Transaction Fee', detail: 'Transaction Fee for included payment services charge', price: '$5.00', amount: '$-5.00', amountClass: 'text-danger' },
        { date: '11 May 2022', orderId: '3059337', type: 'Transaction Fee', detail: 'Transaction Fee for sale IP588000', price: '$5.00', amount: '$-5.00', amountClass: 'text-danger' },
        { date: '11 May 2022', orderId: '3059337', type: 'Sale', detail: { title: 'DevUIUX HTML web and admin templates', invoice: 'IP588000' }, price: '$100.00', amount: '$100.00', amountClass: 'text-success' }
    ], []);
    return (
        <>

            {/* page title */}
            <div className="container py-3">
                <div className="row align-items-center page-title">
                    <div className="col col-sm mb-3 mb-sm-0">
                        <h6 className="mb-0">Statement</h6>
                        <p className="text-secondary small">Track your Earning & Payment</p>
                    </div>
                    <div className="col-auto ps-0 position-relative mb-3 mb-sm-0">
                        <button className="btn btn-link btn-square" type="button" data-bs-toggle="offcanvas" data-bs-target="#filter" aria-expanded="false">
                            <i className="bi bi-funnel"></i>
                        </button>
                    </div>
                </div>
                <nav aria-label="breadcrumb" className="breadcrumb-theme bg-theme-1-subtle px-2 py-1 mt-0 mt-sm-3 rounded">
                    <ol className="breadcrumb mb-0">
                        <li className="breadcrumb-item bi"><Link to="/app/dashboard"><i className="bi bi-house-door me-2"></i> DevUIUX</Link></li>
                        <li className="breadcrumb-item bi"><Link to="/app/my-profile"> My Profile</Link></li>
                        <li className="breadcrumb-item bi active" aria-current="page"> statement</li>
                    </ol>
                </nav>
            </div>

            {/* content */}
            <div className="container" id="main-content">
                <div className="row gx-3 gx-lg-4">
                    <div className="col-12 col-md-6 col-lg-8 mb-3 mb-lg-4">
                        <div className="card h-100">
                            <div className="card-header">
                                <h6 className="mb-1">Earnings</h6>
                                <p className="text-secondary">Your sales and earning in last 30 days</p>
                            </div>
                            <div className="card-body pb-0">
                                <div className="row gx-3 gx-lg-4">
                                    <div className="col-6 col-md-auto mb-3 mb-mb-4">
                                        <p className="text-secondary mb-1">My Balance</p>
                                        <h4>1254.00 <small className="fs-12">USD</small></h4>
                                    </div>
                                    <div className="col-6 col-md-auto mb-3 mb-mb-4">
                                        <p className="text-secondary mb-1">Earnings</p>
                                        <h4 className="text-success">+654.00 <small className="fs-12">USD</small></h4>
                                    </div>
                                    <div className="col-6 col-md-auto mb-3 mb-mb-4">
                                        <p className="text-secondary mb-1">Tax Applied</p>
                                        <h4>0.00 <small className="fs-12">USD</small></h4>
                                    </div>
                                    <div className="col-6 col-md-auto mb-3 mb-mb-4">
                                        <p className="text-secondary mb-1">Subscription</p>
                                        <h4 className="text-danger">-64.00 <small className="fs-12">USD</small></h4>
                                    </div>
                                </div>
                            </div>
                            <div className="card-footer border-top">
                                <p className="text-secondary">Your payout will be processed on March 15, 2022</p>
                            </div>
                        </div>
                    </div>
                    <div className="col-12 col-md-6 col-lg-4 mb-3 mb-lg-4">
                        <div className="card ">
                            <div className="card-header">
                                <h6>View Report</h6>
                            </div>
                            <div className="card-body">
                                <div className="form-floating mb-3">
                                    <select className="form-select" id="floatingSelect" aria-label="Floating label select example" defaultValue={"1"}>
                                        <option value={""}>Select Duration</option>
                                        <option value="1">May 2022</option>
                                        <option value="2">April 2022</option>
                                        <option value="3">March 2022</option>
                                    </select>
                                    <label htmlFor="floatingSelect">Select Duration</label>
                                </div>
                                <div className="row gx-3 align-items-end">
                                    <div className="col">
                                        <p className="text-secondary mb-1">Download Invoices in </p>
                                        <p>
                                            <a className="btn btn-sm btn-theme theme-red me-1"><i className="bi bi-file-earmark-pdf vm me-1"></i> PDF</a>
                                            <a className="btn btn-sm btn-theme theme-green"><i className="bi bi-table vm me-1"></i> Excel</a>
                                        </p>
                                    </div>
                                    <div className="col-auto">
                                        <p className="text-secondary"><a className="btn btn-sm btn-theme"><i className="bi bi-printer vm me-1"></i> Print</a></p>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>

                <ul className="nav nav-sm nav-pills overflow-x-auto w-100 flex-nowrap text-nowrap pb-3 pb-lg-4">
                    <li className="nav-item">
                        <a className="nav-link active" aria-current="page" >Last 30 days</a>
                    </li>
                    <li className="nav-item">
                        <a className="nav-link" >June 2022</a>
                    </li>
                    <li className="nav-item">
                        <a className="nav-link" >May 2022</a>
                    </li>
                    <li className="nav-item">
                        <a className="nav-link">April 2022</a>
                    </li>
                    <li className="nav-item">
                        <a className="nav-link">March 2022</a>
                    </li>
                </ul>

                {/* payout history */}
                <div className="card mb-3 mb-lg-4 overflow-hidden">
                    <div className="card-header">
                        <h6 className="fw-medium mb-1">Order statements</h6>
                        <p className="small text-secondary">All the orders and statements are in your Local timezone</p>
                    </div>
                    <div className="card-body pt-0">
                        <DataTable className="table mb-3" options={options}>
                            <thead className="bg-theme">
                                <tr>
                                    <th>Date</th>
                                    <th className="tablet desktop">Order ID</th>
                                    <th className="tablet desktop">Type</th>
                                    <th className="tablet desktop">Detail</th>
                                    <th className="tablet desktop">Price</th>
                                    <th>Amount</th>
                                </tr>
                            </thead>
                            <tbody>
                                {statementData.map((item, index) => (
                                    <tr key={index}>
                                        <td>{item.date}</td>
                                        <td>{item.orderId}</td>
                                        <td>{item.type}</td>
                                        <td>
                                            {typeof item.detail === 'string' ? (
                                                item.detail
                                            ) : (
                                                <>
                                                    <p className="mb-1">{item.detail.title}</p>
                                                    <p className="text-secondary mb-0">Invoice: <a>{item.detail.invoice}</a></p>
                                                </>
                                            )}
                                        </td>
                                        <td>{item.price}</td>
                                        <td className={item.amountClass}>{item.amount}</td>
                                    </tr>
                                ))}
                            </tbody>
                        </DataTable>
                    </div>
                </div>
            </div>

        </>
    );
};

export default Statement;
